<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="list">
          <router-link :to="{path:'/ExploreA1Detail/'+item.id}" tag="div" class="item" :key="index" v-for="(item,index) in dataList">
           <img class="item-l" :src="item.picUrl" alt="">
           <div class="item-r">
             <div class="text">
               <div class="title text-hide">{{item.title}}</div>
               <div class="info" v-html="item.detail"></div>
             </div>
             <div class="date">
               <span>{{parseTime(new Date(item.addTime),'{d}')}}</span>
               <span>{{parseTime(new Date(item.addTime),'{y}-{m}')}}</span>
             </div>
           </div>
          </router-link>
          <div style="clear: both"></div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[5, 10, 15, 20, 25]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="config.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api"
  // import {getExploreA1} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";
  import {mixin} from '@/mixin/index'

  export default {
    name: "List",
    mixins:[mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        config: {
          classify: '',
          total: 0,
          page: 1,
          limit: 5
        },
        dataList:[]
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.toGetData()
      }
    },
    created(){
      // 设置背景颜色
      document.body.style.backgroundColor = "#f6f8fa"
      // 获取数据
      this.toGetData()
    },
    methods:{
      // 获取数据
      async toGetData(val) {
        this.dataList = []
        let params = {
          pageNum: this.config.page,
          pageSize: this.config.limit,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "举重新闻",
          articleKey:"cms",
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows,total}} = await getSingle(params)
        // console.log(rows,total)
        rows.forEach( val => {
          this.dataList.push({
            id : val.id,
            title : val.smallTitle,
            detail: val.bigTitle,
            addTime:val.updateTime,
            picUrl : this.$store.getters.urlApi + val.faceUrl
          })
        })
        this.config.total = total
      },
      // toGetData() {
      //   getExploreA1(this.config).then((res) => {
      //     this.dataList = res.data.data.list
      //     this.config.total = res.data.data.count
      //   })
      // },
      // 分页事件
      handleSizeChange(val) {
        this.config.limit = val
        this.toGetData()
      },
      handleCurrentChange(val) {
        this.config.page = val
        this.toGetData()
      }
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }
  .container{
    .wrap{
      width: 1380px;
      background: #FFFFFF;
      padding: 60px 60px 50px;
      margin: 0 auto 60px;
      .list{
        .item {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          padding-top: 50px;
          padding-bottom: 50px;
          border-bottom: 1px solid #e3e3e3;
          .item-l{
            width: 380px;
          }
          .item-r{
            width: 810px;
            display: flex;
            justify-content: space-between;
            .text{
              width: 660px;
              .title{
                font-family: PingFangSC;
                font-weight: 600;
                font-size: 28px;
                color: #333333;
              }
              .info{
                font-family: Source Han Sans CN;
                font-size: 20px;
                color: #666666;
                line-height: 36px;
                margin-top: 20px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
                overflow: hidden;
                height: 186px;
                text-align: justify;
              }
            }
            .date{
              width: 110px;
              padding-left: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              position: relative;
              margin-left: 30px;
              span:nth-child(1){
                font-size: 48px;
                color: #DA1E2D;
                line-height: 1;
                margin-bottom: 10px;
                font-weight: 600;
              }
              span:nth-child(2){
                font-size: 20px;
              }
              &:after{
                content: "";
                width: 1px;
                height: 50%;
                background: #eee;
                position: absolute;
                left: 0;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
              }
            }
          }
        }
        .item:nth-child(1){
          padding-top: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Explore/A1/List.vue